// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3JpuH","row":"ProcedureTreatmentSummary_row__2yWVJ"};